/** @type {Set<string>} 成品油税收分类编码 */
const refinedOilCode: Map<string, string> = new Map();

refinedOilCode.set('107010101', '汽油类');
refinedOilCode.set('107010102', '煤油类');
refinedOilCode.set('107010103', '柴油类');
refinedOilCode.set('107010104', '燃料油类');
refinedOilCode.set('107010105', '石脑油类');
refinedOilCode.set('107010106', '溶剂油类');
refinedOilCode.set('107010107', '润滑油类');
refinedOilCode.set('106040101', 'test');

// const tspz: Map<string, string> = new Map();
// tspz.set('01', 'SPECIAL');
// tspz.set('02', 'FREIGHT_TRANSPORT');
// tspz.set('03', 'VEHICLE');
// tspz.set('04', 'POPULAR');
// tspz.set('08', 'SPECIAL_ELECTRONIC');
// tspz.set('10', 'ELECTRONICS');
// tspz.set('11', 'VOLUME');
// tspz.set('14', 'TOLL');
// tspz.set('15', 'USED_CAR');

// const Tspz = {
//     '01': 'SPECIAL', // 纸质专票
//     '02': 'FREIGHT_TRANSPORT', // 货运发票 
//     '03': 'VEHICLE' , // 机动车票
//     '04': 'POPULAR' , // 纸质普票
//     '08': 'SPECIAL_ELECTRONIC' , // 电子专票
//     '10': 'ELECTRONICS' , // 电子普票
//     '11': 'VOLUME' , // 卷票
//     '14': 'TOLL' , // 道路通行费电子普通发票
//     '15': 'USED_CAR' , // 二手车票
// };
// 0:待执行 1:申请中 2:申请失败 3:申请成功
//  4:下载中 5:下载失败 6:下载成功  8:解析中 9:解析失败 
// 10:解析成功 11:审核未通过  12:审核通过 13:查询失败  14:文件已过期  99:无内容
const TaskStatusEnum = {
    0: '待执行' ,
    1: '申请中' ,
    2: '申请失败' ,
    3: '申请成功' ,
    4: '下载中' ,
    5: '下载失败' ,
    6: '下载成功' ,
    8: '解析中' ,
    9: '解析失败' ,
    10: '解析成功' ,
    11: '审核未通过' ,
    12: '审核通过' ,
    13: '查询失败' ,
    14: '文件已过期' ,
    99: '无内容' ,
};

const tspz: Map<string, string> = new Map();
tspz.set('00', '一般票种');
tspz.set('01', '农产品销售');
tspz.set('02', '农产品收购');
tspz.set('08', '成品油');

enum Tspz {
    '一般票种' = '00',
    '农产品销售' = '01',
    '农产品收购' = '02',
    '成品油' = '08'
}
export default {
    refinedOilCode,
    Tspz,
    TaskStatusEnum
};


// WEBPACK FOOTER //
// ./src/utils/Doc/Code.ts